import { useTranslation } from 'react-i18next';
import HexLogomark from './ui/HexLogomark';

const HeroSection = () => {
  const { t } = useTranslation();

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="hero">
      <div className="dot-grid" />
      <div className="gold-orb gold-orb--primary hero__orb-a" />
      <div className="gold-orb gold-orb--deep hero__orb-b" />
      <div className="gold-orb gold-orb--emerald hero__orb-c" />

      <div className="container hero__container">
        <div className="row align-items-center">
          <div className="col-lg-7 hero__copy">
            <div className="eyebrow" data-aos="fade-up">
              <span>EST. 2026 · BSC · USDT</span>
            </div>

            <h1 className="hero__title" data-aos="fade-up" data-aos-delay="80">
              {t('hero.titleLead')}{' '}
              <span className="gold-text">{t('hero.titleHighlight')}</span>.{' '}
              {t('hero.titleTail')}
            </h1>

            <p className="hero__subtitle" data-aos="fade-up" data-aos-delay="160">
              {t('hero.subtitle')}
            </p>

            <div className="hero__cta" data-aos="fade-up" data-aos-delay="240">
              <button
                type="button"
                className="tg-btn tg-btn-lg"
                onClick={() => scrollToSection('strategies')}
              >
                <i className="fas fa-vault" />
                {t('hero.ctaPrimary')}
                <i className="fas fa-arrow-right" />
              </button>
              <button
                type="button"
                className="tg-btn-two tg-btn-lg"
                onClick={() => scrollToSection('calculator')}
              >
                {t('hero.ctaSecondary')}
              </button>
            </div>

            <div className="hero__trust" data-aos="fade-up" data-aos-delay="320">
              <span><i className="fas fa-shield-halved" /> {t('hero.trust.nonCustodial')}</span>
              <span><i className="fas fa-file-contract" /> {t('hero.trust.audited')}</span>
              <span><i className="fab fa-github" /> {t('hero.trust.openSource')}</span>
              <span><i className="fas fa-lock" /> {t('hero.trust.immutable')}</span>
            </div>
          </div>

          <div className="col-lg-5 hero__visual-col">
            <div className="hero__visual" data-aos="zoom-in" data-aos-delay="200">
              <HexLogomark size={440} />
            </div>
          </div>
        </div>

        {/* Proof bar — live stats */}
        <div className="hero__proof" data-aos="fade-up" data-aos-delay="400">
          <div className="hero__proof-item">
            <div className="hero__proof-label">{t('hero.proof.tvlLabel')}</div>
            <div className="hero__proof-value mono tabular-nums">$45,000,000+</div>
          </div>
          <div className="hero__proof-divider" />
          <div className="hero__proof-item">
            <div className="hero__proof-label">{t('hero.proof.stakersLabel')}</div>
            <div className="hero__proof-value mono tabular-nums">12,400</div>
          </div>
          <div className="hero__proof-divider" />
          <div className="hero__proof-item">
            <div className="hero__proof-label">{t('hero.proof.paidLabel')}</div>
            <div className="hero__proof-value mono tabular-nums">$8,240,000</div>
          </div>
          <div className="hero__proof-divider" />
          <div className="hero__proof-item">
            <div className="hero__proof-label">{t('hero.proof.aprLabel')}</div>
            <div className="hero__proof-value gold-text tabular-nums">438%</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
